var React = require('react');

function CaretRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icon/caret-right"},React.createElement("path",{"id":"Polygon 113","d":"M14.5639 9.37596C15.0092 9.67283 15.0092 10.3272 14.5639 10.624L7.66603 15.2226C7.16761 15.5549 6.5 15.1976 6.5 14.5986L6.5 5.40139C6.5 4.80237 7.16761 4.44507 7.66603 4.77735L14.5639 9.37596Z","fill":"currentColor"})));
}

CaretRight.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = CaretRight;

CaretRight.default = CaretRight;
